var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',[_c('el-main',[_c('el-row',[_c('el-col',{attrs:{"span":24}},[_c('ReportByProductByMonthFilters',{on:{"onYearSelected":_vm.OnYearSelected}})],1)],1),_c('el-row',[_c('el-col',{attrs:{"span":24}},[_c('ReportByProductByMonthTable',{attrs:{"yearSelected":_vm.yearSelected}})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }